module.exports = __webpack_public_path__ + "static/media/folder-with-color.4e1c6dcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/folder-with-color.svg
// module id = 234
// module chunks = 0